import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';

import GraphQL from '../../../GraphQL';
import SmartCard from '../../../shared/components/SmartCard';
import AccountPayableForm from './payable/Form';
import AccountReceivableForm from './receivable/Form';
import { PAYABLE, STATUS_OPENED } from '../../../shared/utils/constants';
import {
  financialById,
  financialSaveMutation,
  financialCancelMutation,
} from '../../../shared/queries/AccountsReceivableAndPayable';
import ModalOptions from './receivable/ModalOptionsSmartPay';
import { getUTCDateFromMilliseconds } from '../../../shared/utils/smartutils';

const FormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({
    id: 0,
    status: STATUS_OPENED,
    inTestEnvironment: false,
    indRepeat: false,
    dueDate: new Date(),
    competencyDate: new Date(),
    automaticBilling: false,
  });
  const [formOn, setFormOn] = useState(false);
  const [modal, setModal] = useState(false);

  function backClickHandler() {
    history.push(`/minime/conta-${match.params.type}`);
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const toggleModal = () => {
    setModal(!modal);
  };

  function findById(id) {
    let query;
    if (match.params.type === PAYABLE) {
      query = '';
    } else {
      query = financialById(id);
    }
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        if (res.financialById) {
          setDto({
            ...res.financialById,
            category: {
              ...res.financialById.category,
              value: res.financialById.category.id,
              label: res.financialById.category.name,
            },
            account: {
              ...res.financialById.account,
              value: res.financialById.account.id,
              label: res.financialById.account.name,
              smartpay: res.financialById.account.smartpay,
            },
            student: {
              ...res.financialById.student,
              value: res.financialById.student.id,
              label: res.financialById.student.fullName,
            },
            responsible: {
              ...res.financialById.responsible,
              value: res.financialById.responsible.id,
              label: res.financialById.responsible.fullName,
            },
            dueDate: getUTCDateFromMilliseconds(res.financialById.dueDate),
            competencyDate: getUTCDateFromMilliseconds(
              res.financialById.competencyDate
            ),
          });
        } else if (res.payable) {
          setDto({
            ...res.payable[0],
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  const handleSubmit = (values) => {
    let mutation;
    if (match.params.type === PAYABLE) {
      mutation = '';
    } else {
      mutation = financialSaveMutation(values);
    }
    showLoading();
    GraphQL(mutation, { description: values.description, obs: values.obs }, t)
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
      });
  };

  const financialCancel = (values) => {
    const mutation = financialCancelMutation(values);
    if (modal) {
      toggleModal();
    }
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t(`screens.mnt_${match.params.type}.title`)}>
      {modal && (
        <ModalOptions
          toggle={toggleModal}
          modal={modal}
          onConfirm={financialCancel}
          dto={dto}
        />
      )}
      {formOn &&
        (match.params.type === PAYABLE ? (
          <AccountPayableForm
            onSubmit={handleSubmit}
            backHandler={backClickHandler}
            showLoading={showLoading}
            hideLoading={hideLoading}
            dto={dto}
          />
        ) : (
          <AccountReceivableForm
            onSubmit={handleSubmit}
            financialCancel={toggleModal}
            backHandler={backClickHandler}
            showLoading={showLoading}
            hideLoading={hideLoading}
            findById={findById}
            dto={dto}
          />
        ))}
    </SmartCard>
  );
};

FormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(FormHandler)
);
